import {sort}   from "@Common/utils/collections";
import {chain}  from "@Common/utils/fs";
import {values} from "@Common/utils/objects";

export const getQuantityErrorMessage = (quantity, {paperPrices, method}) => {
    if (!paperPrices) {
        return "Sorry, we have no pricing policy for the selected paper type";
    }
    if (!quantity) {
        return "Please enter a quantity";
    }

    const priceGap = getPriceGap(quantity, paperPrices);

    if (priceGap.from == null && priceGap.to == null) {
        return "Pricing unavailable";
    }
    if (priceGap.from == null) {
        return `Minimum quantity is ${priceGap.to}`;
    }
    if (priceGap.to == null) {
        return `Maximum quantity is ${priceGap.from-1}`;
    }

    return `No pricing for quantity ${priceGap.from}-${priceGap.to-1}`;
}

const getPriceGap = (quantity, paperPrices) => {
    const coveredPriceRanges = chain(
        values(paperPrices),
        (_) => _.map((pp) => ({from: pp.min, to: !pp.max ? null : pp.max+1})),
        (_) => sort(_, (r) => r.from),
    );

    return getGapRange(quantity, coveredPriceRanges);
};

const getGapRange = (value, ranges) => {
    let index = null;
    for (const range of ranges) {
        if (range.from && range.from > value) {
            // console.log(range, index);
            return {from: index, to: range.from};
        }
        index = range.to;
    }
    return {from: index, to: null};
};

